import Modal from 'react-modal'
import './blackout-modal.css';
import React from 'react';

class BlackoutModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showBlackoutFeedback: false,
      preferredName: ''
    }
    this.openBlackoutFeedback = this.openBlackoutFeedback.bind(this);
    this.closeBlackoutFeedback = this.closeBlackoutFeedback.bind(this);
  }

  openBlackoutFeedback () {
    this.setState({ showBlackoutFeedback: true });
  }
  
  closeBlackoutFeedback () {
    this.setState({ showBlackoutFeedback: false });
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showBlackoutFeedback}
          onRequestClose={this.closeBlackoutFeedback}
          className="Modal"
          overlayClassName="Overlay">
          <i class='bx bxs-flag-alt'></i>
          <div className="title">Voting and comments are now closed.</div>
          <div className="info">The leader is selecting questions to respond to. Stay tuned for their response!</div>
          <div className="cancel" onClick={this.closeBlackoutFeedback}>Close</div>
        </Modal>
      </div>
    );
  }
}

export default BlackoutModal


// WEBPACK FOOTER //
// ./src/components/BlackoutModal.js